import React from "react";
import GridCard from "./GridCard";
import { useNotificationData } from "./hooks/useNotificationData";

interface Props {
  username: string;
  year: string;
  quarter: number;
  display: { KPI: boolean };
}

const cardBase = "bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md p-4";

const NotificationDataCard: React.FC<Props> = ({ username, year, quarter, display }) => {
  const enabled = !!username && display.KPI;
  const { data, loading } = useNotificationData(username, year, quarter, enabled);

  if (!display.KPI) return null;

  return (
    <div className="col-span-12">
      {loading ? (
        <div className={`${cardBase} text-center`}>
          <div className="animate-spin inline-block w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full"></div>
          <p className="mt-2 text-gray-600 dark:text-gray-400">Loading KPIs...</p>
        </div>
      ) : data && data.length > 0 ? (
        <GridCard
          title="Notification Data"
          headers={["Notification Area", "# Created", "# Dismissed", "Avg. Days to Dismiss"]}
          data={data}
          loading={false}
        />
      ) : (
        <div className={`${cardBase} italic text-gray-500 dark:text-gray-400`}>
          No notification data available.
        </div>
      )}
    </div>
  );
};

export default NotificationDataCard;